import React from 'react';
import TextField from 'material-ui/TextField';
import AutoComplete from 'material-ui/AutoComplete';
import styles from './styles.scss';

export default function MaterialTextField(props) {
  const isReduxForm = !!props.input;
  const onChange = isReduxForm ? props.input.onChange : props.onChange;

  let settings = {
    id: props.id,
    floatingLabelText: props.floatingLabelText,
    floatingLabelFixed: props.floatingLabelFixed,
    hintText: props.hintText,
    disabled: props.disabled,
    onFocus: props.onFocus,
    className: _generateClassName(props),
    type: props.type,
    fullWidth: true,
    ref: props.inputRef,
    maxLength: props.maxLength,
    max: props.max,
    autoFocus: props.autoFocus,
    style: props.style,
    name: props.name,
    errorText: props.errorText
  };

  if (isReduxForm) {
    settings.errorText =
      props.meta.touched && !props.noValidate ? props.meta.error : '';
    settings = Object.assign(settings, props.input);
  } else {
    settings.value = props.value;
    settings.onChange = props.onChange;
    settings.onBlur = props.onBlur ? props.onBlur : null;
  }

  if (props.dataSource) {
    settings.dataSource = props.dataSource;
    settings.searchText = settings.value;
    settings.onUpdateInput = searchText => onChange(searchText);
    settings.onNewRequest = searchText => onChange(searchText);
    if (props.placement === 'top') {
      settings.targetOrigin = { vertical: 'bottom', horizontal: 'left' };
      settings.anchorOrigin = { vertical: 'top', horizontal: 'left' };
    }
    settings.listStyle = { maxHeight: '200px', overflow: 'auto' };
    settings.openOnFocus = true;
    settings.filter = _autoCompleteFilter;
  }
  return React.createElement(
    props.dataSource ? AutoComplete : TextField,
    settings
  );
}

const _generateClassName = (
  {
    className = '',
    floatingLabelText,
    disabled,
    hideErrorText,
    normalTop,
    dark
  },
  inputClass = styles.inputControl
) => {
  let concatted = inputClass + (className ? ` ${className}` : '');
  if (floatingLabelText) concatted += ` ${styles.hasFloatingText}`;
  if (disabled) concatted += ` ${styles.disabled}`;
  if (hideErrorText) concatted += ` ${styles.hideErrorText}`;
  if (normalTop) concatted += ` ${styles.normalTop}`;
  if (dark) concatted += ` ${styles.dark}`;
  return concatted;
};

const _autoCompleteFilter = (searchText, key) => {
  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
};



// WEBPACK FOOTER //
// ./src/components/util/materialTextField/index.js